module.exports = __webpack_public_path__ + "img/kite_kitchen.9f6cdb9d.svg";